export const DealerPortalSectionEnumValue = {
  None: 0,
  DisplaysToolingAndFurniture: 1,
  ExteriorSignage: 2,
  MerchandisingServices: 3,
  UsefulLinks: 4,
  PrintOnDemand: 5,
};

export const DealerPortalSectionEnum = [
  {
    value: DealerPortalSectionEnumValue.None,
    name: 'None',
    labelFrench: 'Aucun',
    labelEnglish: 'None',
    useMegaMenu: false,
    showFilter: false,
  },
  {
    value: DealerPortalSectionEnumValue.DisplaysToolingAndFurniture,
    name: 'DisplaysToolingAndFurniture',
    labelFrench: 'Présentoirs, outillage et mobilier',
    labelEnglish: 'Displays, Tooling and Furniture',
    useMegaMenu: false,
    showFilter: false,
  },
  {
    value: DealerPortalSectionEnumValue.ExteriorSignage,
    name: 'ExteriorSignage',
    labelFrench: 'Enseigne extérieure',
    labelEnglish: 'Exterior Signage',
    useMegaMenu: false,
    showFilter: true,
  },
  {
    value: DealerPortalSectionEnumValue.MerchandisingServices,
    name: 'MerchandisingServices',
    labelFrench: 'Services de marchandisage',
    labelEnglish: 'Merchandising Services',
    useMegaMenu: false,
    showFilter: false,
  },
  {
    value: DealerPortalSectionEnumValue.UsefulLinks,
    name: 'UsefulLinks',
    labelFrench: 'Liens utiles',
    labelEnglish: 'Useful Links',
    useMegaMenu: false,
    showFilter: false,
  },
  {
    value: DealerPortalSectionEnumValue.PrintOnDemand,
    name: 'PrintOnDemand',
    labelFrench: 'Impression à la demande',
    labelEnglish: 'Print On Demand',
    useMegaMenu: true,
    showFilter: true,
  },
];

export const getDealerPortalSectionName = sectionValue => {
  const value = Number(sectionValue);
  return DealerPortalSectionEnum.find(section => section.value === value)?.name;
};

export const getDealerPortalSectionValue = sectionNameOrValue => {
  const numericValue = Number(sectionNameOrValue);

  if (!Number.isNaN(numericValue) && DealerPortalSectionEnum.some(section => section.value === numericValue)) {
    return numericValue;
  }

  const normalizedName = String(sectionNameOrValue || '').toLowerCase();
  const matched = DealerPortalSectionEnum.find(section => section.name.toLowerCase() === normalizedName);

  return matched?.value ?? DealerPortalSectionEnumValue.None;
};

export const doesSectionShowFilters = sectionNameOrValue => {
  const sectionValue = getDealerPortalSectionValue(sectionNameOrValue);
  const section = DealerPortalSectionEnum.find(currentSection => currentSection.value === sectionValue);

  return Boolean(section?.showFilter);
};

export const doesSectionUseMegaMenu = sectionNameOrValue => {
  const sectionValue = getDealerPortalSectionValue(sectionNameOrValue);
  const section = DealerPortalSectionEnum.find(currentSection => currentSection.value === sectionValue);

  return Boolean(section?.useMegaMenu);
};

export default DealerPortalSectionEnum;
